import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "warehouseT";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取仓库调拨单列表
    async getWarehouseTList({ commit }, payload) {
      let result = await api.get(
        `/api/Transfers/Detail?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    ///api/Transfers/SingleWarehouseDetail
    //仓库调拨单，出库单，入库单编辑详情
    async wareHouseTDetail({ commit }, payload) {
      var result = await api.get(
        `/api/Transfers/SingleWarehouseDetail?NumberOrder=${payload}`
      );
      return result.data;
    },
    // 获取调拨明细表
    async getAllocationDetail({ commit }, payload) {
      let result = await api.get(
        `/api/Transfers/GetTransfersToPC?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 获取调拨汇总表
    async getTransferSummary({ commit }, payload) {
      let result = await api.get(
        `/api/Transfers/TransferSummary?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 导出报表
    async exportReportT({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/Export?${queryString.stringify(payload)}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
    // 导出-调拨明细表
    async exportAllocationDetail({ commit }, payload) {
      var result = await api.get(
        `/api/Transfers/GetTransfersExport?${queryString.stringify(payload)}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
    // 导出-损溢明细表
    async exportGainLoss({ commit }, payload) {
      var result = await api.get(
        `/api/GainsLoss/ExportDetailToPC?${queryString.stringify(payload)}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
  },
});

export default moduleName;
